export const notificationStyle = {
  NotificationItem: {
    // Override the notification item
    DefaultStyle: {
      // Applied to every notification, regardless of the notification level
      margin: "10px 5px 2px 1px"
    },

    success: {
      // Applied only to the success notification item
      color: "#6B7C93",
      minHeight: 50,
      borderTop: "none"
    },
    error: {
      // Applied only to the success notification item
      color: "#721c24",
      minHeight: 50,
      backgroundColor: "#f8d7da",
      borderTop: "none"
    }
  }
};
